module.exports = __webpack_public_path__ + "static/img/1.b058892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hezuo/1.png
// module id = wh5M
// module chunks = 1